import { responseUtils } from '../utils';

export const hospitalServices = {
    getStatusProntoSoccorso,
    getNedocs,
    
}

function getStatusProntoSoccorso(idHospital, language, intl) {
    const requestOption = {
        method: 'GET',
    }
    return fetch(`${process.env.REACT_APP_API_ENDPOINT}/organization/${idHospital}/status/${language}`, requestOption)
        .then(
            res => responseUtils.handleResponse(res, intl),
            error => responseUtils.handleError(error, intl)
        );
}

function getNedocs(idHospital, intl) {
    const headers = new Headers({
        'Accept': 'application/json'
    });
    const opts = {
        method: 'GET',
        headers,
        mode: 'cors',
        cache: 'default',
    };
    return fetch(`${process.env.REACT_APP_API_ENDPOINT}/organization/${idHospital}/nedocs`, opts)
        .then(
            res => responseUtils.handleResponse(res, intl),
            error => responseUtils.handleError(error, intl)
        );
}


